import styled from 'styled-components';

export const ConfirmBody = styled.div`
  padding: 10px 0 0;
  text-align: center;
`;
